import styled from "styled-components";
import { Typography, Button, Grid } from "@material-ui/core";

export const STWrapper = styled.div`
  height: 100vh;
  background-color: #fff;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: flex-start;
`;

export const STForm = styled.form`
  min-height: 200px;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 15px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
`;

export const STTypography = styled(Typography)`
  &&& {
    font-size: 16px;
  }
`;

export const STButton = styled(Button)`
  && {
    margin-top: 15px;
  }
`;

export const STProvidersGridRoot = styled(Grid)`
  && {
    padding-top: 20px;
    width: 100%;
  }
`;

export const STProvidersGridTitle = styled(Grid)`
  && {
    font-weight: 500;
    padding-bottom: 8px;
  }
`;

export const STProviderImg = styled.img`
  max-height: 20px;
  max-width: 20px;
`;

export const STProviderName = styled.div`
  font-size: 0.9rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
`;

export const STProvidersGridContent = styled.div`
  && {
    display: flex;
    min-width: min-content;
    align-items: center;
    border: 1px solid #d0d0d0;
    border-radius: 4px;
    margin: 6px 4px 6px 4px;
    width: calc(50% - 20px);
    padding: 4px;
    cursor: pointer;
    opacity: 1;
    &:hover {
      opacity: 0.5;
    }
  }
`;

export const STProvidersGrid = styled.div`
  && {
    display: flex;
    margin: -6px -6px;
    flex-wrap: wrap;
  }
`;
